export enum FlexDirectionOption {
    Horizantal = 'row',
    HorizantalReverse = 'row-reverse',
    Vertical = 'column',
    VerticalReverse = 'column-reverse'
}
